/* eslint-disable no-restricted-imports */
/* eslint-disable react/prop-types */
import { t, Trans } from '@lingui/macro'
import Circle from 'assets/images/white-loader.svg'
import BigNumber from 'bignumber.js'
import { ButtonGray, ButtonPrimary } from 'components/Button'
import { Input as NumericalInput } from 'components/NumericalInput'
import { BANK_ADDRESS } from 'constants/addresses'
import { ZERO_ADDRESS } from 'constants/misc'
import { SWC } from 'constants/tokens'
import { ethers } from 'ethers'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useBankContract, useTokenContract } from 'hooks/useContract'
import { useCallback, useEffect, useState } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import { addPopup } from 'state/application/reducer'
import { useUserReferrer } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { CustomLightSpinner, ThemedText } from 'theme'
import { UserDetails } from 'types/user'
import { DEFAULT_TOKEN_DECIMALS } from 'utils/bigNumber'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { isChainAllowed } from 'utils/switchChain'
import { isMobile } from 'utils/userAgent'

import { EnableStatus } from '../types'
import { ConfirmModal } from './ConfirmModal'

const MyDataInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 16px;
  margin-top: 2rem;
`

const StyleDivInput = styled.div`
  display: flex;
  border: 1px solid #8247e5;
  border-radius: 24px;
  flex-direction: row;
  width: 100%;
  padding: 8px;
  justify-content: space-between;
  margin-top: 1rem;
`
const StyledInput = styled(NumericalInput)`
  background-color: transparent;
  text-align: center;
  width: 100%;
  padding: 0 10px;
  font-size: 18px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 16px;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 12px;
  `};
`

interface Props {
  playerData: UserDetails
}

const BuyChips: React.FC<Props> = ({ playerData }) => {
  const { account, chainId, connector } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [hash, setHash] = useState<string | undefined>()
  const [attempting, setAttempting] = useState(false)
  const [enableStatus, setEnableStatus] = useState(EnableStatus.DISABLED)
  const showConnectAWallet = Boolean(!account)
  const [localValue, setLocalValue] = useState('')

  const { swcBalance, chipsBalance } = playerData

  const bigValue = new BigNumber(localValue ? localValue : '0').times(DEFAULT_TOKEN_DECIMALS)
  const hasFunds = swcBalance.gte(bigValue)

  const chainAllowed = chainId && isChainAllowed(connector, chainId)

  const backAddress = BANK_ADDRESS[chainAllowed ? chainId : 137]
  const swcAddress = SWC[chainAllowed ? chainId : 137].address
  const tokenContract = useTokenContract(swcAddress)

  const referrer = useUserReferrer()

  useEffect(() => {
    const checkAllowance = async () => {
      if (chipsBalance.gt(0)) {
        setEnableStatus(EnableStatus.ENABLED)
      } else {
        try {
          const response = await tokenContract?.allowance(account ?? ZERO_ADDRESS, backAddress)
          const currentAllowance = new BigNumber(response ? response?.toString() : 0)
          setEnableStatus(currentAllowance.gt(0) ? EnableStatus.ENABLED : EnableStatus.DISABLED)
        } catch (error) {
          setEnableStatus(EnableStatus.DISABLED)
        }
      }
    }

    if (account) {
      checkAllowance()
    }
  }, [account, tokenContract, setEnableStatus, chipsBalance, backAddress])

  const handleApprove = async () => {
    try {
      setEnableStatus(EnableStatus.IS_ENABLING)
      const response = await tokenContract?.approve(backAddress, ethers.constants.MaxUint256)?.catch(() => {
        setEnableStatus(EnableStatus.DISABLED)
      })
      await response?.wait()

      if (response?.hash) {
        setEnableStatus(EnableStatus.ENABLED)
      }

      addPopup({ message: t`Successfully Enabled!` })
    } catch (error) {
      setEnableStatus(EnableStatus.DISABLED)
    }
  }

  const handleDismissSubmissionModal = useCallback(() => {
    setHash(undefined)
    setAttempting(false)
  }, [setHash, setAttempting])

  const bankContract = useBankContract()

  const handleBuy = async () => {
    try {
      setAttempting(true)
      const value = bigValue.toFixed(0)
      const response = await bankContract?.buyCredits(value, referrer ?? ZERO_ADDRESS)?.catch(() => {
        setAttempting(false)
      })
      await response?.wait()

      if (response?.hash) setHash(response?.hash)
      playerData.fetchData()
    } catch (error) {
      setAttempting(false)
    }
  }

  return (
    <>
      <MyDataInfo>
        <ThemedText.Body fontSize={isMobile ? '12px' : '18px'}>
          <Trans>My SWC</Trans>: {getFullDisplayBalance(swcBalance, 18, 2)}
        </ThemedText.Body>
        <ThemedText.Body fontSize={isMobile ? '12px' : '18px'}>
          <Trans>My CHIPS</Trans>: {getFullDisplayBalance(chipsBalance, 18, 2)}
        </ThemedText.Body>
      </MyDataInfo>
      <div style={{ width: '80%', marginLeft: '10%' }}>
        <StyleDivInput>
          <StyledInput
            className="amount"
            type="number"
            step={0.0}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            placeholder={t`Enter Amount`}
            value={localValue}
            onUserInput={(val) => {
              setLocalValue(val)
            }}
          />
          <ButtonGray
            width={isMobile ? '20%' : '10%'}
            height={isMobile ? '10px' : '10px'}
            disabled={showConnectAWallet}
            onClick={() => {
              setLocalValue(swcBalance ? getFullDisplayBalance(swcBalance, 18, 18) : '0')
            }}
          >
            Max
          </ButtonGray>
        </StyleDivInput>
      </div>
      {/* {displayGetJMS.gt(0) && (
        <MyDataInfo style={{ justifyContent: 'center' }}>
          <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} alignItems="center">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Trans>You will get</Trans>: {displayGetJMS.gt(0) ? getFullDisplayBalance(displayGetJMS, 18, 4) : 0} JMS
            </div>
          </ThemedText.Body>
        </MyDataInfo>
      )} */}
      <div style={{ width: '80%', marginLeft: '10%', marginTop: '1rem' }}>
        {!showConnectAWallet && enableStatus !== EnableStatus.ENABLED && (
          <ButtonPrimary
            style={{ marginTop: '1rem', padding: '8px 16px' }}
            justifyContent="center"
            onClick={handleApprove}
            disabled={enableStatus === EnableStatus.IS_ENABLING}
          >
            {enableStatus === EnableStatus.IS_ENABLING ? (
              <>
                <Trans>Enabling</Trans>{' '}
                <CustomLightSpinner
                  src={Circle}
                  alt="loader"
                  size={'18px'}
                  style={{ marginLeft: '0.5em', textDecoration: 'bold' }}
                />{' '}
              </>
            ) : (
              <Trans>Enable</Trans>
            )}
          </ButtonPrimary>
        )}
        {!showConnectAWallet && enableStatus === EnableStatus.ENABLED && (
          <ButtonPrimary
            justifyContent="center"
            style={{ marginTop: '1rem', padding: '8px 16px' }}
            disabled={bigValue.lte(0) || !hasFunds || attempting}
            onClick={handleBuy}
          >
            {!hasFunds ? <Trans>Insufficient funds</Trans> : <Trans>Buy</Trans>}
          </ButtonPrimary>
        )}

        {showConnectAWallet && (
          <ButtonPrimary style={{ marginTop: '1rem', padding: '8px 16px' }} onClick={toggleWalletModal}>
            <Trans>Connect a wallet</Trans>
          </ButtonPrimary>
        )}
        <ConfirmModal isOpen={attempting} hash={hash} onDismiss={handleDismissSubmissionModal} />
      </div>
    </>
  )
}

export default BuyChips
